var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masked-input',{staticClass:"form-control",attrs:{"mask":_vm.maskOptions,"placeholder":_vm.placeholder,"type":"text"},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }